import { render, staticRenderFns } from "./AiAgentShareSettings.vue?vue&type=template&id=256406f2"
import script from "./AiAgentShareSettings.vue?vue&type=script&lang=js"
export * from "./AiAgentShareSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports